module.exports = __webpack_public_path__ + "img/sdmmovil.0f6a3ef4.jpeg";